var _circle, _path, _rect, _line, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalBrandingContentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 9.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.375 16C30.5408 16 30.6997 15.9398 30.8169 15.8326C30.9342 15.7255 31 15.5801 31 15.4286V14.7166C31.0025 13.1131 28.5162 11.8571 26 11.8571C23.4837 11.8571 21 13.1131 21 14.7166V15.4286C21 15.5801 21.0658 15.7255 21.1831 15.8326C21.3003 15.9398 21.4592 16 21.625 16H30.375ZM28.2525 8.05943C28.2525 8.32988 28.1942 8.59768 28.081 8.84754C27.9678 9.0974 27.8019 9.32443 27.5928 9.51566C27.3836 9.7069 27.1353 9.8586 26.862 9.96209C26.5887 10.0656 26.2958 10.1189 26 10.1189C25.7042 10.1189 25.4113 10.0656 25.138 9.96209C24.8647 9.8586 24.6164 9.7069 24.4072 9.51566C24.1981 9.32443 24.0322 9.0974 23.919 8.84754C23.8058 8.59768 23.7475 8.32988 23.7475 8.05943C23.7475 7.51323 23.9848 6.98941 24.4072 6.60319C24.8297 6.21697 25.4026 6 26 6C26.5974 6 27.1703 6.21697 27.5928 6.60319C28.0152 6.98941 28.2525 7.51323 28.2525 8.05943Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 28,
    rx: 1.5,
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 6.5,
    x2: 17.5,
    y2: 6.5,
    stroke: "white",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 6.5L39.5 6.5",
    stroke: "white",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5H12.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5H12.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5H12.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5H12.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24H36.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 4,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalBrandingContentIcon);
export default __webpack_public_path__ + "static/media/personalBrandingContentIcon.aeff648ade9c80cb696266437c365060.svg";
export { ForwardRef as ReactComponent };